function updateToken (ctx, token) {
  ctx.commit('updateToken', token)
}
function updateUid (ctx, uid) {
  ctx.commit('updateUid', uid)

}
function updateheadpicurl (ctx, url) {
  ctx.commit('updateheadpicurl', url)
}
function updateUserName (ctx, name) {
  ctx.commit('updateUserName', name)
}
function updatePath (ctx, name) {
  ctx.commit('updatePath', name)
}
function updateLevel (ctx, name) {
  ctx.commit('updateLevel', name)
}
function updateCommunity (ctx, type) {
  ctx.commit('updateCommunity', type)
}
function updateCommunityid (ctx, id) {
  ctx.commit('updateCommunityid',id)
}
function updateCityCode (ctx, cityCode) {
  ctx.commit('updateCityCode',cityCode)
}
function updateCityLatLng (ctx, cityLatLng) {
  ctx.commit('updateCityLatLng',cityLatLng)
}
function updateIsAdmin (ctx, num) {
  ctx.commit('updateIsAdmin',num)
}
function updateUsertypeid (ctx, id) {
  ctx.commit('updateUsertypeid',id)
}
function updateinitid (ctx, initid) {
  ctx.commit('updateinitid', initid)
}
function updatelocation (ctx, location) {
  ctx.commit('updatelocation', location)
}
function updateApptype (ctx, apptype) {
  ctx.commit('updateApptype', apptype)
}
export default {
  updateToken,
  updateUid,
  updateheadpicurl,
  updateUserName,
  updatePath,
  updateLevel,
  updateCommunity,
  updateCommunityid,
  updateCityCode,
  updateCityLatLng,
  updateIsAdmin,
  updateUsertypeid,
  updateinitid,
  updatelocation,
  updateApptype
}
